import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { PeopleDetailResponseData } from "../../types/people";

export const getData = async (
  id: string | undefined,
): Promise<PeopleDetailResponseData> => {
  const { data } = await api.get<PeopleDetailResponseData>(`/profile/${id}`);

  return data;
};

export const usePeopleDetail = (
  id: string | undefined,
): QueryObserverBaseResult<PeopleDetailResponseData> => {
  const { data, ...props } = useQuery(queryKeys.people(id), () => getData(id), {
    enabled: Boolean(id),
  });
  return { data, ...props };
};
